
const Loader: React.FC = () => {
  return (
    <div className="flex justify-center items-center bg-white">
      <div className="relative flex justify-center items-center">
        {/* 🔵 Aro 1 */}
        <div className="absolute animate-spin-slow rounded-full h-32 w-32 border-t-4 border-zinc-800 border-opacity-70"></div>

        {/* 🟣 Aro 2 (gira en dirección opuesta y ligeramente inclinado) */}
        <div className="absolute animate-spin-reverse rounded-full h-28 w-28 border-t-4 border-zinc-500 border-opacity-70 rotate-45"></div>

        {/* 💬 Texto fijo en el centro */}
        <span className="absolute text-zinc-600 font-semibold text-lg tracking-wide">
          LinkServs
        </span>
      </div>
    </div>
  );
};

export default Loader;
